export default __webpack_public_path__ + "static/media/logoForLogin.f5707d73.png";